const { REACT_APP_BASE_URL: BASE_URL } = process.env
const { REACT_APP_BASE_URL_PROD: BASE_URL_PROD } = process.env
export const BA_URL = `${BASE_URL}/api/v1/ba`
export const API_URL = `${BASE_URL}/api/v1/ba/business-accounts`
export const AUTH_URL = `${BASE_URL}/api/v1`
export const BASE_URL1 = `${BASE_URL}`

export const ADMIN_ROLES = ['client', 'business']

export const APP_LAST_UPDATE = '2024.05'

export const LanguageHeader = () => {
  const lang = localStorage.getItem('app.settings.locale') || 'en'
  return { 'Accept-Language': lang }
}

export const mapboxTileLayerProps = {
  attribution: `© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>`,
  url: `https://api.mapbox.com/styles/v1/{id}/tiles/512/{z}/{x}/{y}?access_token={accessToken}`,
  id: process.env.REACT_APP_MAPBOX_STYLE,
  tileSize: 512,
  zoomOffset: -1,
  accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
}

export default {
  API: {
    USERS: `${API_URL}/employees`,
    ADDRESS: `${BASE_URL_PROD}/search?layers=address,venue&lat=44.43&lng=26.1`,
    ADDRESS_ONLY_STREET: `${AUTH_URL}/autocompleteStreet?layers=address,venue&lat=44.43&lng=26.1`,
  },
}
